// src/components/admin/blog/SlugGenerator.jsx
import React, { useState, useEffect, useRef } from 'react';
import { slugify } from '../../../utils/slugify';
import { FiRefreshCw, FiCheck, FiEdit2 } from 'react-icons/fi';

export const SlugGenerator = ({ title, onSlugChange, existingSlug = '' }) => {
  const [slug, setSlug] = useState(existingSlug || '');
  const [isEditing, setIsEditing] = useState(false);
  const [isAuto, setIsAuto] = useState(!existingSlug);
  const isFirstRender = useRef(true);

  // Generate slug when title changes (only when auto is enabled and not editing)
  useEffect(() => {
    if (isAuto && !isEditing && title && !isFirstRender.current) {
      const generatedSlug = slugify(title);
      if (generatedSlug !== slug) {
        setSlug(generatedSlug);
        onSlugChange(generatedSlug);
      }
    }
    isFirstRender.current = false;
  }, [title, isAuto, isEditing, slug, onSlugChange]);

  const handleGenerateSlug = () => {
    if (title) {
      const generatedSlug = slugify(title);
      setSlug(generatedSlug);
      onSlugChange(generatedSlug);
    }
  };

  const handleSlugChange = e => {
    const newSlug = slugify(e.target.value);
    setSlug(newSlug);
    onSlugChange(newSlug);
  };

  const toggleAuto = () => {
    setIsAuto(!isAuto);
    if (!isAuto && title) {
      const generatedSlug = slugify(title);
      setSlug(generatedSlug);
      onSlugChange(generatedSlug);
    }
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1 flex items-center gap-2 flex-wrap">
          <span className="text-sm" style={{ color: 'var(--muted)' }}>
            https://wdhejbul.com/blog/
          </span>
          {isEditing ? (
            <input
              type="text"
              value={slug}
              onChange={handleSlugChange}
              className="flex-1 min-w-[200px] px-3 py-1.5 rounded-lg border focus:outline-none focus:ring-2 focus:ring-blue-500 bg-transparent"
              style={{ borderColor: 'var(--border)', color: 'var(--text)' }}
              autoFocus
              onBlur={() => setIsEditing(false)}
            />
          ) : (
            <span
              className="cursor-pointer hover:underline break-all"
              style={{ color: 'var(--text)' }}
              onClick={() => setIsEditing(true)}
            >
              {slug || 'your-slug'}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1 flex-shrink-0">
          <button
            onClick={handleGenerateSlug}
            className="p-1.5 rounded-lg hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
            title="Generate slug"
          >
            <FiRefreshCw className="w-4 h-4" />
          </button>
          <button
            onClick={toggleAuto}
            className={`p-1.5 rounded-lg transition-colors ${
              isAuto
                ? 'bg-blue-500 text-white'
                : 'hover:bg-black/5 dark:hover:bg-white/5'
            }`}
            title={isAuto ? 'Auto-generate on' : 'Auto-generate off'}
          >
            <FiCheck className="w-4 h-4" />
          </button>
        </div>
      </div>
      <p className="text-xs" style={{ color: 'var(--muted)' }}>
        URL-friendly version of the title. Only lowercase letters, numbers, and
        hyphens allowed.
      </p>
    </div>
  );
};
